<template>
  <div class="linkedin__container">
    <LinkedInContent />
    <Footer />
  </div>
</template>

<script>
import Footer from "../components/Footer.vue";
import LinkedInContent from "../components/LinkedInContent.vue";
export default {
  // eslint-disable-next-line vue/no-unused-components
  components: { LinkedInContent, Footer },
  name: "LinkedIn",
};
</script>
